export var IM_MessageType;

(function (IM_MessageType) {
  IM_MessageType["MessageFromPeer"] = "peer-message";
  IM_MessageType["PrescriptionMessage"] = "prescription-message";
  IM_MessageType["CallStatusUpdateSystemMessage"] = "call-status-update-message";
  IM_MessageType["UserStatusUpdateSystemMessage"] = "peer-status-update-message";
})(IM_MessageType || (IM_MessageType = {}));